import {addClass, closest, on, findIn, removeClass, findAllIn} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

const selectors = {
    base: '.js-sb-test',
    question: '.js-sb-test__question',
    questionText: '.js-sb-test__question-text',
    input: '.js-sb-test__question-input',
    questionButton: '.js-sb-test__question-btn',
    nextButton: '.js-sb-test__next',
    prevButton: '.js-sb-test__prev',
    currentStep: '.js-sb-test__current',
    category: '.js-sb-test__category',
    progress: '.js-sb-test__progress'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let questionButtons = findAllIn(selectors.questionButton, baseElement);
        let questions = findAllIn(selectors.question, baseElement);
        let prevButton = findIn(selectors.prevButton, baseElement);
        let nextButton = findIn(selectors.nextButton, baseElement);

        prevButton.setAttribute('disabled', true);
        nextButton.setAttribute('disabled', true);

        let question = findIn(selectors.question + '.is-active', baseElement)
        setActiveCategory(question, baseElement);

        questionButtons.map(function(btn) {
            on('click', function(evt) {
                let btn = evt.target;
                let value = btn.getAttribute('data-sb-test-value');
                let question = closest(selectors.question, btn);
                let currentIndex = +question.getAttribute('data-sb-test-number');
                let input = findIn(selectors.input, question);
                if(value) {
                    input.value = value;
                    let nextIndex = currentIndex+1;
                    navigateToStep(question, nextIndex);
                    window.dataLayer = window['dataLayer'] || [];
                    let currentQuestionText = findIn(selectors.questionText, question).getAttribute('data-sb-test-question');

                    let trackingData = {
                        'event': 'genericGtmEvent',
                        'genericEventCategory': 'Säure-Basen-Test',
                        'genericEventAction': 'Frage beantwortet',
                        'genericEventLabel': currentQuestionText
                    };
                    window.dataLayer.push(trackingData);
                }
            }, btn);
        })

        on('click', function() {
            let currentStep = +findIn(selectors.currentStep, baseElement).textContent;
            let nextIndex = currentStep -1;
            let question = findIn(selectors.question + '.is-active', baseElement)
            navigateToStep(question, nextIndex, true);
        }, prevButton);

        on('click', function() {
            let currentStep = +findIn(selectors.currentStep, baseElement).textContent;
            let nextIndex = currentStep +1;
            let question = findIn(selectors.question + '.is-active', baseElement)
            navigateToStep(question, nextIndex);
        }, nextButton);

        function navigateToStep(currentQuestion, newIndex, goBack = false) {
            if(newIndex <= questions.length) {
                let currentStep = findIn(selectors.currentStep, baseElement);
                currentStep.innerHTML = newIndex;

                if(!goBack) {
                    addClass('is-answered', currentQuestion);
                    setProgressBar(currentQuestion, baseElement);
                }

                removeClass('is-active', currentQuestion);
                let newQuestion = findIn(`[data-sb-test-number='${newIndex}']`, baseElement);
                setActiveCategory(newQuestion, baseElement);
                addClass('is-active', newQuestion);

                if(newIndex === 1) {
                    prevButton.setAttribute('disabled', true);
                } else {
                    prevButton.removeAttribute('disabled');
                }

                let inputValue = findIn(selectors.input, newQuestion).value || false;
                if(newIndex === questions.length || !inputValue) {
                    nextButton.setAttribute('disabled', true);
                } else {
                    nextButton.removeAttribute('disabled');
                }
            } else {
                setProgressBar(currentQuestion, baseElement);
                baseElement.submit();
            }
        }
    });
}

function setActiveCategory(question, baseElement) {
    let categoryId = question.getAttribute('data-sb-test-category');
    let newCategory = findIn(selectors.category + `[data-sb-test-category='${categoryId}']`, baseElement);
    let allCategories = findAllIn(selectors.category, baseElement);
    allCategories.map( cat => cat.setAttribute('hidden', true));
    newCategory.removeAttribute('hidden');
}

function setProgressBar(question, baseElement) {
    let categoryId = question.getAttribute('data-sb-test-category');
    let newCategory = findIn(selectors.progress + `[data-sb-test-category='${categoryId}']`, baseElement);
    let allQuestionsOfCategory = findAllIn(selectors.question + `[data-sb-test-category='${categoryId}']`, baseElement).length;
    let alreadyAnsweredQuestionsOfCategory = findAllIn(selectors.question + `.is-answered[data-sb-test-category='${categoryId}']`, baseElement).length;

    let newPercentage = alreadyAnsweredQuestionsOfCategory/allQuestionsOfCategory*100;
    newCategory.style.width = newPercentage + '%';
}